<template>
  <div>
    <MasterDetail
      formTitle="Lançamento de Timesheet (ICT)"
      :cols="cols"
      :opts="opts"
      :customResource="customResource"
      descriptionProperty="data"
      :hasExportCSV="false"
      :hasExportXLSX="false"
      serverPagination
      cancelButtonTextOnly
    >
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div class="table-v-action-button mr-3" v-bind="attrs" v-on="on">
            <v-icon>mdi-file-delimited-outline</v-icon>
            Exportações
          </div>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title class="table-v-action-button" @click="exportarAsync()">
              <v-icon>mdi-file-delimited</v-icon>
              XLSX Assíncrono
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </MasterDetail>
    <v-dialog v-model="exportacaoAsyncDialog" scrollable persistent max-width="400">
      <v-card>
        <v-card-title style="display: block" class="pb-1">
          <v-icon x-large class="mr-3">mdi-file-delimited-outline</v-icon>
          Exportar Relatório
          <v-btn @click="exportacaoAsyncDialog = false" style="position: absolute; right: 5px; top: 5px" icon>
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p>Requisição entrou na fila para processamento.</p>
          <p>Para ver o progresso e baixar o relatório, veja a fila.</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-6 pb-3 pt-0">
          <v-spacer></v-spacer>
          <v-btn color="primary" class="pr-5" dark depressed @click="exportacaoAsyncDialog = false">
            <v-icon left>mdi-chevron-left</v-icon> Fechar
          </v-btn>
          <v-btn color="primary" dark depressed class="px-5 ml-3" @click="verFila()">
            Ver fila
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MasterDetail from "@/components/master-detail.vue";
import ictTimesheetService from "@/api/ict/ictTimesheet.service";
import ictProjetosService from "@/api/ict/ictProjetos.service";
import ictUsuariosService from "@/api/ict/ictUsuarios.service";

export default {
  name: "IctTimesheet",
  components: {
    MasterDetail,
  },
  computed: {
    empresaId() {
      return this.$store.getters.clientId;
    },
    customResource() {
      const empresaId = this.empresaId;
      return {
        get: (params) => ictTimesheetService.getAll(empresaId, params),
        save: (data, id) => {
          if (data.data && data.data.length > 10) {
            data.data = data.data.substring(0, 10);
          }
          const promise = id
            ? ictTimesheetService.update(empresaId, id, data)
            : ictTimesheetService.create(empresaId, data);
          return promise.catch(e => {
            const data = e.response?.data;
            const fieldErrors = data?.errors;
            const firstFieldError = fieldErrors
              ? Object.values(fieldErrors)[0]?.[0]
              : null;
            return { error: firstFieldError || data?.message || "Falha ao salvar timesheet." };
          });
        },
        delete: (id) => {
          return ictTimesheetService.remove(empresaId, id)
            .catch(e => {
              const errorMsg = e.response?.data?.message || "Falha ao excluir timesheet.";
              this.$notify({ group: "geral", duration: 5000, type: "error", title: "Erro", text: errorMsg });
            });
        },
      };
    },
  },
  data() {
    return {
      exportacaoAsyncDialog: false,
      cols: [
        {
          key: "id",
          name: "ID",
          hideInform: true,
        },
        {
          key: "usuario_id",
          name: "Usuário",
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: { to: "usuarios", key: "id", name: "nome" },
          colSize: 6,
          rules: [{ rule: "required" }],
        },
        {
          key: "data",
          name: "Data",
          type: this.$fieldTypes.DATE,
          colSize: 6,
          rules: [{ rule: "required" }],
        },
        {
          key: "projeto_id",
          name: "Projeto",
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: { to: "projetos", key: "id", name: "nome_projeto" },
          colSize: 6,
          rules: [{ rule: "required" }],
        },
        {
          key: "tempo",
          name: "Horas",
          type: this.$fieldTypes.NUMBER,
          colSize: 4,
          rules: [{ rule: "required" }],
        },
        {
          key: "atividade",
          name: "Atividade",
          type: this.$fieldTypes.TEXTAREA,
          colSize: 12,
        },
      ],
      opts: {
        projetos: [],
        usuarios: [],
      },
    };
  },
  watch: {
    empresaId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadProjetos();
          this.loadUsuarios();
        }
      },
    },
  },
  methods: {
    async loadProjetos() {
      try {
        const response = await ictProjetosService.getAll(this.empresaId);
        this.opts.projetos = (response && response.data) ? response.data : (response || []);
      } catch (e) {
        console.error("Erro ao carregar projetos", e);
      }
    },
    async loadUsuarios() {
      try {
        const response = await ictUsuariosService.selecao(this.empresaId);
        this.opts.usuarios = (response && response.data) ? response.data : (response || []);
      } catch (e) {
        console.error("Erro ao carregar usuários", e);
      }
    },
    exportarAsync() {
      const md = this.$children.find(c => c.$options.name === 'MasterDetail');
      const filters = md ? md.pageTableFilters : {};

      this.apiResource(`v1/clientes/${this.empresaId}/exportacao`)
        .save({
          tipoRelatorio: "ict-timesheet",
          filters: JSON.stringify(filters),
        })
        .then(() => {
          this.exportacaoAsyncDialog = true;
        });
    },
    verFila() {
      this.$router.push({ path: "/clientes/dashboard/relatorios-exportados" });
    },
  },
};
</script>
